{
  "summary": {
    "title": "Resumen ejecutivo con IA",
    "subtitle": "Generado por Claude · contexto solo de este proyecto",
    "last_n_days": "Últimos {n} días",
    "regenerate": "Regenerar",
    "analyzing": "Analizando actividad…",
    "error": "No se pudo generar el resumen.",
    "stat_completed": "Completadas",
    "stat_created": "Creadas",
    "stat_comments": "Comentarios",
    "disclaimer": "La IA puede equivocarse. Verifica datos críticos."
  }
}
